import http from "../http-common";

class OrderService {
    /**
     * Create order and Razorpay order
     */
    createOrder(data) {
        return http.post("order/create", data);
    }

    /**
     * Verify payment after Razorpay success
     */
    verifyPayment(data) {
        return http.post("order/payment/verify", data);
    }

    /**
     * Get single order details
     */
    getOrder(orderId) {
        return http.get(`order/${orderId}`);
    }

    /**
     * Get customer's all orders
     */
    getCustomerOrders(customerId) {
        return http.get(`order/customer/${customerId}`);
    }
}

export default new OrderService();